// Default API key - consider moving to Lovable Secrets for production
const DEFAULT_API_KEY = "6bc47d96e4e5aaf01639e5f29762fee2";

interface WeatherResponse {
  weather: Array<{
    id: number;
    main: string;
    description: string;
  }>;
  main: {
    temp: number;
  };
  name: string;
}

export interface WeatherData {
  location: string;
  description: string;
  temp: number;
  weatherCode: number;
}

export const fetchWeatherData = async (
  cityName: string,
  lat?: number,
  lon?: number,
  apiKey?: string
): Promise<WeatherData> => {
  const key = apiKey || DEFAULT_API_KEY;
  
  // Prioritize coordinates for accuracy, fallback to city name
  const url = (lat !== undefined && lon !== undefined)
    ? `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${key}&units=metric&lang=es`
    : `https://api.openweathermap.org/data/2.5/weather?q=${encodeURIComponent(cityName)}&appid=${key}&units=metric&lang=es`;

  try {
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Weather API error: ${response.status}`);
    }

    const data: WeatherResponse = await response.json();

    return {
      location: cityName || data.name,
      description: data.weather[0].description,
      temp: Math.round(data.main.temp),
      weatherCode: data.weather[0].id
    };
  } catch (error) {
    console.error("Error fetching weather data:", error);
    throw error;
  }
};
